'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.opts = exports.reducers = exports.initialState = exports.defaultUser = undefined;

var _identity2 = require('lodash/identity');

var _identity3 = _interopRequireDefault(_identity2);

var _constant2 = require('lodash/constant');

var _constant3 = _interopRequireDefault(_constant2);

var _reducers;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _capeRedux = require('cape-redux');

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultUser = exports.defaultUser = { id: 'anonUser', type: 'Person', name: 'Anonymous' };

var initialState = exports.initialState = {
  auth: null,
  authenticated: false,
  token: null,
  tokenSent: false,
  tokenSending: false,
  tokenValid: null,
  tokenValidating: false,
  user: defaultUser
};
function setUser(state, _ref) {
  var error = _ref.error,
      payload = _ref.payload;
  var authenticated = initialState.authenticated,
      tokenSending = initialState.tokenSending,
      tokenValidating = initialState.tokenValidating;

  return _extends({}, state, {
    authenticated: error ? authenticated : true,
    tokenSending: tokenSending,
    tokenValid: !error,
    tokenValidating: tokenValidating,
    user: payload
  });
}
function wPay(actionReducer) {
  return function (state, action) {
    return actionReducer(state, action.payload);
  };
}
var reducers = exports.reducers = (_reducers = {}, _defineProperty(_reducers, _actions.LOGIN, setUser), _defineProperty(_reducers, _actions.LOGOUT, (0, _constant3.default)(initialState)), _defineProperty(_reducers, _actions.TOKEN, wPay((0, _capeRedux.set)('token'))), _defineProperty(_reducers, _actions.TOKEN_REQ, wPay((0, _capeRedux.fpMerge)({ tokenSending: true }))), _defineProperty(_reducers, _actions.TOKEN_VALIDATE, wPay((0, _capeRedux.fpMerge)({ token: null, tokenSending: false, tokenValidating: true }))), _defineProperty(_reducers, _actions.USER_ID, wPay((0, _capeRedux.setIn)(['user', 'id']))), _defineProperty(_reducers, _actions.USER_NEW, wPay((0, _capeRedux.set)('user'))), _reducers);
var opts = exports.opts = { skipErrors: false, actionPick: _identity3.default };
var reducer = (0, _capeRedux.createReducer)(reducers, initialState, opts);
exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-auth/lib/reducer.js
// module id = 835
// module chunks = 0